export const LOGIN_REQUEST = "LOGIN_REQUEST";
export const LOGIN_RESPONSE = "LOGIN_RESPONSE";

export const LOGOUT_REQUEST = "LOGOUT_REQUEST";

export const CHANGE_PASSWORD_REQUEST = "CHANGE_PASSWORD_REQUEST";
export const CHANGE_COMPANY_PASSWORD_REQUEST = "CHANGE_COMPANY_PASSWORD_REQUEST";
export const CHANGE_CLIENT_PASSWORD_REQUEST = "CHANGE_CLIENT_PASSWORD_REQUEST";
export const CHANGE_PASSWORD_SETTLED = "CHANGE_PASSWORD_SETTLED";

export const FORGET_PASSWORD_REQUEST = "FORGET_PASSWORD_REQUEST";

export const GET_PERMISSION_REQUEST = "GET_PERMISSION_REQUEST";
export const GET_PERMISSION_RESPONSE = "GET_PERMISSION_RESPONSE";
